<template>
  <div>
    <el-dialog title="添加备注" :visible.sync="dialogRemark" width="50%" :before-close="remarkCancel">
      <form>
        <div class="form-line">
          <div class="textBox" style="width: 155px;">
          <span class="line-text">
            可选模板标语<el-tooltip class="item" effect="dark" content="模板标语可复制粘贴至备注文本文案,模板之间请用/分开" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>：
          </span>
          </div>
          <div style="width: 500px; height: 50px;display: flex;overflow-y: hidden;flex-wrap: nowrap;">
            <el-tag v-for="(item,index) in copyList" :key="index" class="copyButton" style="margin-right: 10px;cursor: pointer;margin-bottom: 5px" :data-clipboard-text="item.name" @click="copy">{{item.name}}</el-tag>
          </div>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">名称：</span>
          </div>
          <el-input v-model="formDataRemark.name" size="small" style="width: 300px">
          </el-input>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">文本：</span>
          </div>
          <el-input
            v-model="formDataRemark.dynamicText"
            type="textarea"
            class="class-textarea"
            placeholder="请输入文本"
            :rows="4"
            style="width: 300px">
          </el-input>
        </div>
      </form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="remarkCancel">取 消</el-button>
        <el-button size="small" type="primary" @click="remarkConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ButtonCancel from "../../../components/Button/ButtonCancel";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import TextTitle from "../../../components/Text/TextTitle";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TableMain from "../../../components/Table/TableMain";
import Clipboard from "clipboard";
import {nError, nSuccess} from "../../../utils/notice";

export default {
  name: "valueDialog",
  props: {
    dialogRemark: {
      type: Boolean,
      default: false
    },
    copyList: {
      type: Array
    }
  },
  data() {
    return {
      formDataRemark: {
        name: '',
        dynamicText: '',
      },
    }
  },
  methods: {
    // 取消
    remarkCancel() {
      this.$emit('remarkCancel');
    },

    // 提交
    remarkConfirm() {
      this.$emit('remarkConfirm',this.formDataRemark)
    },

    // 复制
    copy() {
      let clipboard = new Clipboard(".copyButton");
      clipboard.on("success", e => {
        nSuccess("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        nError("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    }
  }
}
</script>

<style scoped>
::-webkit-scrollbar {
  /*滚动条整体样式*/
  /*width: 10px; !*高宽分别对应横竖滚动条的尺寸*!*/
  height: 5px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
//background-color: #8c8c8c;
  background-color: rgba(0, 0, 0, 0.25);
}

::-webkit-scrollbar-track {
  background-color: #f6f6f6;
}
::-webkit-scrollbar-thumb,
::-webkit-scrollbar-track {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/Invoice/invoiceremarks/remarkDialog.vue